import React, { useState, useEffect } from 'react'
import { client } from '../../client'
import { images } from '../../constants'
import { AppWrap, MotionWrap } from '../../wrapper'
import './Footer.scss'
import emailjs from  'emailjs-com'



const Footer = () => {

  const [formData, setFormData] = useState({ name: '', email: '',  message: '' })
  const [isFormSubmitted, setIsFormSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)

  const { name, email, message} = formData 

  const handleChangeInput = (e) => {
    const { name, value } = e.target
    // console.log(e)

    setFormData({ ...formData, [name]: value })
  }  

  const handleSubmit = () => {
    setLoading(true)

    const contact = {
      _type: 'contact',
      name: name,
      email: email,
      message: message,
    }

    client.create(contact)
    .then(() => {
      setLoading(false)
      setIsFormSubmitted(true)
    })

  }


  const sendEmail = (e) => {
      e.preventDefault();

      emailjs.sendForm('service_iksg8xs', 'template_jg4vhkk', e.target, 'fkGpNmf7q68dqAijG')
          .then((result) => {
              console.log(result.text);
          }, (error) => {
              console.log(error.text);
          })
  }

  return (
    <>
      <h2 className="head-text">You can <span>contact me</span> here.</h2>
      <div className="app__footer-cards">
        <div className="app__footer-card">
          <img src={images.email} alt="email" />
          <a href="mailto:naveednaseer7@gmail.com" className="p-text">naveednaseer7@gmail.com</a>
        </div>
      </div>
      {/* <div className="app__footer-cards">
        <div className="app__footer-card">
          <img src={images.mobile} alt="mobile" />
          <a href="tel:1234567890" className="p-text">+91 6114834406</a>
        </div> 
      </div> */}

      <form onSubmit={sendEmail} className="form-head">
        {!isFormSubmitted ? 
          <div className="app__footer-form app__flex">
            <div className="app__flex">
              <input className="p-text" type="text" placeholder="Your Name" name="name" value={name} onChange={handleChangeInput} />
            </div>

            <div className="app__flex">
              <input className="p-text" type="email" placeholder="Your Email" name="email" value={email} onChange={handleChangeInput} />
            </div>

            <div>
              <textarea 
                className="p-text"
                placeholder="Your Message" 
                value={message}
                name="message"
                onChange={handleChangeInput}
              />
            </div>
            <button className="p-text" type="submit" onClick={handleSubmit}>{loading ? 'Sending' : 'Send Message'}</button>
          </div>  
        : <div>
            <h3 className="head-text">Thank You For Contacting Me, <span>I Will Get Back To You Soon.</span></h3>
          </div>
        }
      </form>
    </>
  )
}

// export default Footer
export default AppWrap(MotionWrap(Footer, 'app__footer'), 'contact', 'app_primary_bg')